module.exports = __webpack_public_path__ + "static/img/step2.e8a9084.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/DefineRadiance/img/step2.svg
// module id = 454
// module chunks = 0